import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BroadbandCAF = () => {
  const navigate = useNavigate();
  const [cafDataAll, setCafDataAll] = useState([]);
  const [cafDataPending, setCafDataPending] = useState([]);
  const [cafDataInsPending, setCafDataInsPending] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputAll, setSearchInputAll] = useState('');
  const [searchInputPending, setSearchInputPending] = useState('');
  const [searchInputInsPending, setSearchInputInsPending] = useState('');
  const [searchFilter, setSearchFilter] = useState([]);
  const [flagAll, setFlagAll] = useState(false);
  const [flagPending, setFlagPending] = useState(false);
  const [flagInsPending, setFlagInsPending] = useState(false);

  useEffect(() => {
    const fetchData = async (status, dataFunction) => {
      try {
        setLoading(true);
        // const currentDate = new Date();
        // const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        // const toDate = formattedCurrentDate;
        // console.log("toDate",toDate);
        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toLocaleDateString('en-CA'); // 'YYYY-MM-DD' format
        const toDate = formattedCurrentDate;
        // console.log("toDate", toDate);

        const fromDate = new Date(currentDate);
        fromDate.setMonth(currentDate.getMonth() - 3);
        const formattedFromDate = fromDate.toISOString().split('T')[0];

        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getAllCAF",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          businessSegment: "Home",
          fromDate: formattedFromDate,

          password: sessionStorage.getItem('password'),
          searchBoxValue: "",
          status: status,
          toDate: toDate,
          // toDate: "2025-03-02",
          userName: sessionStorage.getItem('userName'),

        };

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });

        if (response.ok) {
          const result = await response.json();
          // console.log('API Response:', result);

          if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            // console.log('Actual Data:', result.Response.Data);
            dataFunction(result.Response.Data);
          } else {
            const errorMessage = (result && result.Response && result.Response.Message);
            // console.log("errorMessage", errorMessage);
            //   toast.warning(`${errorMessage}`, {
            //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
            // });
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        // toast.warning('Error fetching data. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchData("All", setCafDataAll);
    fetchData("not equals Installation Completed", setCafDataPending);
    fetchData("Installation Completed", setCafDataInsPending);
  }, []);

  const handleSearchAll = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllCAF",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Home",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputAll,
        "status": "All",
        "toDate": "",
        "userName": sessionStorage.getItem('userName')

      };

      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        if (result && result.Response && result.Response.Data) {
          setSearchFilter(result.Response.Data);
          setFlagAll(true);
        } else {
          // console.error("Invalid response format:", result);
          const errorMessage = (result && result.Response && result.Response.Message);
          //    toast.warning(`${errorMessage}`, {
          //      position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          //  });
          // console.log("errorMessage",errorMessage);
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchPending = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllCAF",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Home",
        "fromDate": "",

        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputPending,
        "status": "not equals Installation Completed",
        "toDate": "",
        "userName": sessionStorage.getItem('userName')

      };

      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        if (result && result.Response && result.Response.Data) {
          setSearchFilter(result.Response.Data);
          setFlagPending(true);
        } else {
          // console.error("Invalid response format:", result);
          const errorMessage = (result && result.Response && result.Response.Message);
          // console.log("errorMessage", errorMessage);
          //    toast.warning(`${errorMessage}`, {
          //      position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          //  });
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchInsPending = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllCAF",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "Home",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputInsPending,
        "status": "Installation Completed",
        "toDate": "",
        "userName": sessionStorage.getItem('userName')

      };
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        if (result && result.Response && result.Response.Data) {
          setSearchFilter(result.Response.Data);
          setFlagInsPending(true);
        } else {
          // console.error("Invalid response format:", result);
          const errorMessage = (result && result.Response && result.Response.Message);
          //    toast.warning(`${errorMessage}`, {
          //      position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
          //  });
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const redirectBroadbandPage = () => {
    navigate("/broadband");
  };
  const manageCafForm = (Cafid) => {
    // console.log('Cafid',Cafid);

    navigate(`/broadbandCAFmanageForm?CafId=${Cafid}`);

  }
  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span className="" style={{ cursor: "pointer" }} onClick={redirectBroadbandPage}>
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Broadband CAF</span>
        </div>
        {/* Navigation tabs: ALL ,Pending , Inst.completed */}
        <div className=" container-fluid">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className="nav-link active" data-bs-toggle="tab" href="#allCaf">All CAF</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#pending">Pending</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-bs-toggle="tab" href="#InstCompleted">INST. Completed</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content tab-main-content">
        {/* ****************** ALL CAF TAB ************* */}
        <div className="tab-pane fade show active" id="allCaf">
          <div className="container-fluid mt-1 mb-3  p-2 Searchbar-bg ">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputAll}
                  onChange={(e) => setSearchInputAll(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchAll}>Search</button>

            </div>
          </div>

          {/* ***********All content of ALL CAF TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagAll && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {cafDataAll.map((caf, index) => (
                    <div className="col" key={index} onClick={() => manageCafForm(caf.Cafid)}>
                      <div className="card mb-3" >
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="caf-card-title">{caf.LeadName} ({caf.Cafid})</p>
                            <p className="caf-card-text">Mobile No : {caf.MobileNo}</p>
                            <p className="caf-card-text">Email ID : {caf.EmailID}</p>
                            <p className="caf-card-text">Status : <span className='caf-statusColor'>{caf.Status}</span></p>
                            <p className="caf-card-text" style={{ lineHeight: "15px" }}>Sub Status : {caf.Substatus}</p>
                            <p className="caf-card-text">Created on : {caf.CreatedOn}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text " style={{ color: 'red' }} >OTP Auth Date : {caf.OtpAuthDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}


          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>

              </div>
            </div>
          ) : (
            flagAll && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter.map((caf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(caf.Cafid)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="caf-card-title">{caf.LeadName} ({caf.Cafid})</p>
                            <p className="caf-card-text">Mobile No : {caf.MobileNo}</p>
                            <p className="caf-card-text">Email ID : {caf.EmailID}</p>
                            <p className="caf-card-text">Status : <span className='caf-statusColor'>{caf.Status}</span></p>
                            <p className="caf-card-text" style={{ lineHeight: "15px" }}>Sub Status : {caf.Substatus}</p>
                            <p className="caf-card-text">Created on : {caf.CreatedOn}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text " style={{ color: 'red' }} >OTP Auth Date : {caf.OtpAuthDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}
        </div>

        {/* ****************** Pending TAB ************* */}
        <div className="tab-pane fade show" id="pending">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputPending}
                  onChange={(e) => setSearchInputPending(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchPending}>Search</button>
            </div>
          </div>

          {/* ***********All content of pending TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagPending && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {cafDataPending.map((caf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(caf.Cafid)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="caf-card-title">{caf.LeadName} ({caf.Cafid})</p>
                            <p className="caf-card-text">Mobile No : {caf.MobileNo}</p>
                            <p className="caf-card-text">Email ID : {caf.EmailID}</p>
                            <p className="caf-card-text">Status : <span className='caf-statusColor'>{caf.Status}</span></p>
                            <p className="caf-card-text" style={{ lineHeight: "15px" }}>Sub Status : {caf.Substatus}</p>
                            <p className="caf-card-text">Created on : {caf.CreatedOn}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text " style={{ color: 'red' }} >OTP Auth Date : {caf.OtpAuthDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}


          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>

              </div>
            </div>
          ) : (
            flagPending && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter.map((caf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(caf.Cafid)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="caf-card-title">{caf.LeadName} ({caf.Cafid})</p>
                            <p className="caf-card-text">Mobile No : {caf.MobileNo}</p>
                            <p className="caf-card-text">Email ID : {caf.EmailID}</p>
                            <p className="caf-card-text">Status : <span className='caf-statusColor'>{caf.Status}</span></p>
                            <p className="caf-card-text" style={{ lineHeight: "15px" }}>Sub Status : {caf.Substatus}</p>
                            <p className="caf-card-text">Created on : {caf.CreatedOn}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text " style={{ color: 'red' }} >OTP Auth Date : {caf.OtpAuthDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}


        </div>

        {/* ****************** closed Inst Completed TAB ************* */}
        <div className="tab-pane fade show" id="InstCompleted">
          <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
            <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
              <span>
                <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputInsPending}
                  onChange={(e) => setSearchInputInsPending(e.target.value)} />
                <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button className='btn-sm border-0 bg-light' onClick={handleSearchInsPending}>Search</button>
            </div>
          </div>

          {/* ***********All content of Inst Completed TAB************ */}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            !flagInsPending && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {cafDataInsPending.map((caf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(caf.Cafid)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="caf-card-title">{caf.LeadName} ({caf.Cafid})</p>
                            <p className="caf-card-text">Mobile No : {caf.MobileNo}</p>
                            <p className="caf-card-text">Email ID : {caf.EmailID}</p>
                            <p className="caf-card-text">Status : <span className='caf-statusColor'>{caf.Status}</span></p>
                            <p className="caf-card-text" style={{ lineHeight: "15px" }}>Sub Status : {caf.Substatus}</p>
                            <p className="caf-card-text">Created on : {caf.CreatedOn}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text " style={{ color: 'red' }} >OTP Auth Date : {caf.OtpAuthDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}

          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt='loading....' ></img>
              </div>
            </div>
          ) : (
            flagInsPending && (
              <div className='container-fluid'>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                  {searchFilter.map((caf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(caf.Cafid)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                            <p className="caf-card-title">{caf.LeadName} ({caf.Cafid})</p>
                            <p className="caf-card-text">Mobile No : {caf.MobileNo}</p>
                            <p className="caf-card-text">Email ID : {caf.EmailID}</p>
                            <p className="caf-card-text">Status : <span className='caf-statusColor'>{caf.Status}</span></p>
                            <p className="caf-card-text" style={{ lineHeight: "15px" }}>Sub Status : {caf.Substatus}</p>
                            <p className="caf-card-text">Created on : {caf.CreatedOn}</p>
                            <p className="caf-card-text">Created By : {caf.CreatedBy}</p>
                            <p className="caf-card-text " style={{ color: 'red' }} >OTP Auth Date : {caf.OtpAuthDate}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
          )}


        </div>
      </div>

    </>
  )
}

export default BroadbandCAF;
